export enum LandingNames {
	BUSSINES = 'credit-bussines-card',
	CREDITS = 'credits',
	RKO = 'rko',
	SELF_EMPLOYED = 'self-employed',
	VED = 'ved',
}
